<template>
  <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
    <div style="margin:0 auto;width:80%;padding:10px 0" >
            <span style="display: block"><i
                class="fa fa-asterisk text-danger font10 ml-1"
                aria-hidden="true" ></i>平台ID</span>
      <el-select v-model="formData.platform_id"  style="margin-bottom: 5px;width: 100%">
        <el-option
            v-for="item in PlatArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="item.disabled"
        />
      </el-select>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>项目名称</span>
      <el-input

                placeholder="请输入内容"
                v-model="formData.project_name"
                style="margin-bottom: 5px"
                clearable>
      </el-input>
      <span>项目ID</span>
      <el-input
          placeholder="请输入内容"
          v-model="formSData.project_id"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <span>项目实体编码</span>
      <el-input
          placeholder="请输入内容"
          v-model="formSData.project_real_code"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库类型</span>
      <el-input
                                 v-model="formData.database_type"
                                placeholder="请输入内容"
                                style="margin-bottom: 5px"
                                clearable>
      </el-input>
      <span style="margin-top:15px"><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>服务用名</span>
      <el-input
                                placeholder="请输入内容"
                            v-model="formData.database_server_name"
                                style="margin-bottom: 5px"
                                clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库名称</span>
      <el-input
          v-model="formData.database_name"
          placeholder="请输入内容"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库用户名</span>
      <el-input
                placeholder="请输入内容"
                v-model="formData.database_user"
                style="margin-bottom: 5px"
                clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库密码</span>
      <el-input
                placeholder="请输入内容"
                v-model="formData.database_passwd"
                style="margin-bottom: 5px"
                clearable>
      </el-input>


      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库ip地址</span>
      <el-input
                placeholder="请输入内容"
                v-model="formData.database_ip"
                style="margin-bottom: 5px"
                clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库端口号</span>
      <el-input
          @input="()=>(formData.database_port=formData.database_port.replace(/[^\d.]/g,''))"
                placeholder="请输入内容"
                style="margin-bottom: 5px"
                v-model="formData.database_port"
                clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库外网访问ip</span>
      <el-input
                placeholder="请输入内容"
                v-model="formData.real_ip"
                style="margin-bottom: 5px"
                clearable>
      </el-input>
      <span><i
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>数据库外网访问端口号</span>
      <el-input
          @input="()=>(formData.real_port=formData.real_port.replace(/[^\d.]/g,''))"
                placeholder="请输入内容"
                v-model="formData.real_port"
                style="margin-bottom: 5px"
                clearable>
      </el-input>
      <span>备注</span>
      <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="formSData.remark"
          style="margin-bottom: 5px"
          clearable>
      </el-input>
      <el-button type="primary" style="margin-left: 50%; transform:translateX(-100%)" @click="addSource">确定</el-button> <el-button style="transform: translateX(-80%)" @click="closelog">取消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "new_input",
  props: [
    'Data'
  ],
  data() {
    return {
  formData: {
    platform_id:'',
    project_name:'',
    database_type:'',
    database_server_name:'',
    database_name:'',
    database_user:'',
    database_passwd:'',
    database_ip:'',
    database_port:'',
    real_ip:'',
    real_port:'',
  },
      formSData:{
        project_id:'',
        project_real_code:'',
        remark: '',
      },


      PlatArr: [],
      runbol: false,
    };

  },
  created() {
  },
  mounted() {
  this.query_all_plat()

  },
  methods: {
    closelog(){
      this.$emit('close',false)
      this.formData.project_name = ''
      this.formData.database_type = ''
      this.formData.database_server_name = ''
      this.formData.database_name = ''
      this.formData.database_user = ''
      this.formData.database_passwd = ''
      this.formData.database_ip = ''
      this.formData.database_port = ''
      this.formData.real_ip = ''
      this.formData.real_port = ''
    },
    addSource(){
      console.log(this.formData)
       for (let i in this.formData) {
         if (this.formData[i] === '') {
           this.runbol = false
         } else {
           this.runbol = true
         }
       }
        this.add_new_line()




    },
    add_new_line(){

      if (this.runbol === false) {
        this.$message({
          message: '请填写完整信息',
          type: 'warning'
        });
      } else {
        let obj3 = Object.assign(this.formData,this.formSData)
        console.log(obj3)
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/DeliveryPlatform/CreateNewDataSource',
          data: {
            "version": "v1.1",
            "timestamp": "0",
            "data":obj3
          },
        }).then((response) => {
              console.log(response.data.result)
          if (response.data.result === 200){
            this.$message({
              message: '添加成功',
              type: 'success'
            });
            this.$emit('AddSuccess',false)
          }
            }
        ).catch((error) => {
          console.log(error)
        })
      }
    },
    query_all_plat() {
      this.PlatArr = []
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "object_code": '10',
        },
      }).then((response) => {
        console.log(response.data.content.data)
        console.log(this.PlatArr)
        response.data.content.data.forEach(item => {
          if(item.id !== '10-0000000000000000'){
            this.PlatArr.push(item)
          }
        })
        this.formData.platform_id = this.PlatArr[0].id
      })
    },
    // server_name_disabled() {
    //   this.server_name_chose = true
    // },
    // database_type_chose_disabled() {
    //   this.database_type_chose = true
    // },
    // disabled() {
    //   this.disabled_chose = true
    // },

  }
}
</script>

<style scoped>

</style>
